<template>
  <div class="layout">
        <Layout>
            <Sider ref="side1" breakpoint="md" hide-trigger collapsible collapsed-width="63" v-model="isCollapsed" :style="{background: '#f5f7f9'}">
                <Menu :isCollapse="isCollapsed" :MenuList="MenuList" :defaultactive="defaultactive" @MenuSelectHandle="MenuSelectHandle"></Menu>
            </Sider>
            <Layout>
                <Header :style="{padding: 0}" class="layout-header-bar">
                    <Icon @click.native="collapsedSider" :class="rotateIcon" :style="{margin: '0 20px'}" type="md-menu" size="24"></Icon>
                    <span class="header-Functionpath">{{this.path1}}</span>
                    <span class="header-Functionpath">/</span>
                    <span class="header-Functionpath">{{this.path2}}</span>
                    <span class="header-Functionpath">/</span>
                    <span class="header-Functionpath" :style="{color: '#515a6e'}">{{this.path3}}</span>
                    <HomeHeader :style="{float: 'right'}" v-if="headerhide"/>
                </Header>
                <Content :style="{margin: '10px', background: '#f5f7f9', minHeight: '300px'}">
                  <TopMenu @MenuSelectHandle="MenuSelectHandle"/>
                    <router-view/>
                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import Menu from '../Home/compenents/Menu.vue'
import HomeHeader from './compenents/Header/Header.vue'
import TopMenu from './compenents/TopMenu.vue'
// import { Menuinfo } from '../../api/Menu'
export default {
  name: 'Home',
  components: {
    Menu,
    HomeHeader,
    TopMenu
  },
  mounted: function () {
    this.GetMenuInfo() // 获取菜单数据
  },
  data () {
    return {
      isCollapsed: true,
      clientWidth: document.documentElement.clientWidth,
      headerhide: true,
      MenuList: [],
      path1: '',
      path2: '',
      path3: '',
      defaultactive: ''
    }
  },
  computed: {
    rotateIcon () {
      return [
        'menu-icon',
        this.isCollapsed ? 'rotate-icon' : ''
      ]
    },
    menuitemClasses () {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    }
  },
  methods: {
    collapsedSider () {
      this.$refs.side1.toggleCollapse()
      if (this.siderwidth < 63 && !this.isCollapsed) {
        this.headerhide = false
      } else {
        this.headerhide = true
      }
    },
    // 获取菜单数据
    GetMenuInfo () {
      this.MenuList = this.$store.state.MenuList
    },
    // 菜单选择后回调
    MenuSelectHandle (path1, path2, path3, MenuID) {
      this.path1 = path1
      this.path2 = path2
      this.path3 = path3
      this.defaultactive = MenuID
    }
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .header-Functionpath{
    display: none;
  }
}
.layout{
        border: 1px solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }
    .layout-header-bar{
        background: #fff;
        box-shadow: 0 1px 1px rgba(0,0,0,.1);
    }
    .layout-logo-left{
        width: 90%;
        height: 30px;
        background: #5b6270;
        border-radius: 3px;
        margin: 15px auto;
    }
    .menu-icon{
        transition: all .3s;
    }
    .rotate-icon{
        transform: rotate(-90deg);
    }
    .menu-item span{
        display: inline-block;
        overflow: hidden;
        width: 69px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
    }
    .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }
    .collapsed-menu span{
        width: 0px;
        transition: width .2s ease;
    }
    .collapsed-menu i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
    .header-Functionpath{
      margin: 0 .5rem;
      color: #999999
    }
</style>
